// extracted by mini-css-extract-plugin
export default {"tabList":"tabGroup_tabList","tab":"tabGroup_tab","panels":"tabGroup_panels"};